import { ReferralsScreen } from '@features/referrals/ui/ReferralsScreen'
import { ReferralReceivingNotice } from '@features/onboarding-kyc/ui/ReferralReceivingNotice'

export function IndicacoesPage() {
  return <ReferralsScreen receivingNotice={<ReferralReceivingNotice />} />
}
